var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcnInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M6 11.143A5.143 5.143 0 1 0 6 .857a5.143 5.143 0 0 0 0 10.286M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5.571 5a.429.429 0 0 1 .857 0v3.714a.429.429 0 0 1-.857 0zM5.571 3.286a.429.429 0 1 1 .857 0 .429.429 0 0 1-.857 0"
})));
export default SvgIcnInfo;